'use strict';
import Swiper from 'swiper';

export default class Clients {
  constructor() {
    this.name = 'clients';

    var clientsSwiper = new Swiper('.clients-swiper-container', {
      slidesPerView: 5,
      spaceBetween: 30,
      slidesPerGroup: 5,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
      loopFillGroupWithBlank: false,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },

      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 10,
          slidesPerGroup: 2
        }
      },

      pagination: {
        el: '.clients-swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
    });
  }
}
